module.exports = __webpack_public_path__ + "img/close_up_mold_2.5a10492f.jpg";